<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="title-wrapper">
            <div>
                <h1 class="title-default">Configurações de Pessoas</h1>
                <p class="welcome-message">
                    <button mat-icon-button routerLink="../">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Configurações e preferências do cadastro de pessoas.
                </p>
            </div>
        </div>

        @if (isLoading) {
        <div class="row">
            <div class="col-12 mt-4">
                <div class="row section-separator">
                    <div class="col-12 mb-4">
                        <app-loading-box height="20" width="250"></app-loading-box>
                        <div class="mt-1">
                            <app-loading-box height="16" width="350"></app-loading-box>
                        </div>
                    </div>
                    <div class="col-12 mb-4">
                        <app-loading-box height="20" width="250"></app-loading-box>
                        <div class="mt-1">
                            <app-loading-box height="16" width="350"></app-loading-box>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6 margin-bottom-15">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                    <div class="col-12 margin-bottom-15">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                    <div class="col-12 margin-bottom-15">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
        } @else {
        <form [formGroup]="form">
            <div class="row">
                <div class="col-12">
                    <div class="toggle-content">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="isRestritoVendedor">
                            Restringir acesso dos vendedores
                        </mat-slide-toggle>
                        <span class="info-text">Apenas pessoas vinculadas ao vendedor serão visíveis a ele</span>
                    </div>
                </div>

                <div class="col-12">
                    <div class="toggle-content">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="isVincularAutomaticamente">
                            Vincular automaticamente
                        </mat-slide-toggle>
                        <span class="info-text">Vincular automaticamente Pessoa ao vendedor ao criar o contato</span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 margin-bottom-15">
                    <mat-form-field appearance="outline">
                        <mat-label>Limite de Crédito Padrão</mat-label>
                        <input matInput [currencyMask]="currencyMask" formControlName="limiteCreditoPadrao">
                        <mat-hint>Valor para novos cadastros</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-12 margin-bottom-15">
                    <app-select-pesquisavel [control]="idTipoPessoa" [offlineList]="listaTipoPessoa"
                        label="Tipo Pessoa padrão" idField="id" nameField="descricao" [isOptional]="true">
                    </app-select-pesquisavel>
                </div>
                <div class="col-12 margin-bottom-15">
                    <app-select-pesquisavel [control]="listIdTipoContato" [offlineList]="listaTipoContato"
                        label="Tipo de contato padrão" idField="id" nameField="descricao" [multiple]="true"
                        [isOptional]="true">
                    </app-select-pesquisavel>
                </div>
            </div>

        </form>

        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>